import React from "react";
import PropTypes from "prop-types";
import Icon from "wonderbly-components/lib/Icon";
import isEmpty from "lodash/isEmpty";
import { allowEdit } from "../CartItems/LineItem/helpers";
import RichText from "../Prismic/RichText";
import Price from "../Price";
import EditableContent from "./EditableContent";
import LineItemImage from "./LineItemImage/LineItemImage";

const FixedContent = (props) => (
  <React.Fragment>
    {!isEmpty(props.expandedCustomisation) ? (
      <span className="line-item-customisation">
        <RichText fields={props.expandedCustomisation} />
      </span>
    ) : (
      <React.Fragment>
        <span className="line-item-customisation">
          {props.customisationString || ""}
        </span>
        <span className="line-item-option">
          {props.displayFormat}
          {!isEmpty(props.addons) &&
            props.addons.map((addon) => ` + ${addon.label}`)}
        </span>
      </React.Fragment>
    )}
  </React.Fragment>
);

FixedContent.propTypes = {
  expandedCustomisation: PropTypes.array,
  customisationString: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  displayFormat: PropTypes.string.isRequired,
  addons: PropTypes.array.isRequired,
};

const getTitle = (title, customisationString, lineItemPrefix) => (
  <>
    {title}
    {customisationString && lineItemPrefix && (
      <>
        <span> {lineItemPrefix} </span>
        {customisationString}
      </>
    )}
  </>
);

const LineItemContent = (props) => {
  const title = getTitle(
    props.title,
    props.customisationString,
    props.lineItemPrefix
  );

  const isEditable = allowEdit(props) && props.isEditable;

  return (
    <>
      <LineItemImage
        addons={props.addons}
        title={title}
        edit={{
          editUrl: props.editUrl,
          isEditable: isEditable,
          handleEdit: props.onClickLink.editItem,
        }}
        backgroundColor={props.product?.productInformation?.backgroundColor}
        image={props.item.coverImage || props.image}
      />
      <div className="line-item-ii-content">
        <div>
          <h3 className="line-item-ii-title">{title}</h3>
          {isEditable ? (
            <EditableContent {...props} />
          ) : (
            <FixedContent {...props} />
          )}
        </div>
        <Price
          className="line-item-ii-price"
          price={props.price}
          savings={props.savings}
          savingPriceString={props.savingsPriceLabel}
          savingsType="saved"
        />
      </div>
      {props.isRemovable && (
        <button
          key="line-item-delete"
          onClick={props.onRemove}
          className="line-item-ii-delete"
        >
          <Icon icon="delete" />
        </button>
      )}
    </>
  );
};

LineItemContent.propTypes = {
  isEditable: PropTypes.bool,
  isRemovable: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  image: PropTypes.object,
  addons: PropTypes.array.isRequired,
  item: PropTypes.object,
  title: PropTypes.string.isRequired,
  price: PropTypes.object,
  savings: PropTypes.object,
  savingsPriceLabel: PropTypes.string,
  customisationString: PropTypes.string,
  lineItemPrefix: PropTypes.string,
  editUrl: PropTypes.string,
  onClickLink: PropTypes.object,
  product: PropTypes.object,
};

export default LineItemContent;
